(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eye-exam-landing"] && !Shopify.designMode) return;
  try {
    
let dateShortcutTimer;
document.addEventListener('click', (event) => {
  const link = event.target.closest('.tv-exam__date-link[data-exam-date]');
  if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
  clearInterval(dateShortcutTimer);
  const target = link.dataset.examDate;
  if (!/^202610(08|13|20|27)$/.test(target)) return;
  const day = String(Number(target.slice(6)));
  const started = Date.now();
  dateShortcutTimer = setInterval(() => {
    if (Date.now() - started > 10000) {
      clearInterval(dateShortcutTimer);
      return;
    }
    const grid = document.querySelector('.neo-date-grid-bookeasy');
    if (!grid || !grid.getClientRects().length) return;
    const month = grid.querySelector('.bookeasy-calendar-month-text');
    if (!month || !/^oct(?:ober|obre)?\.?\s+2026$/i.test(month.textContent.trim())) return;
    const cell = Array.from(grid.querySelectorAll('.neo-cell-enabled-bookeasy')).find(
      (item) => item.textContent.trim() === day
    );
    if (!cell || !cell.getClientRects().length) return;
    clearInterval(dateShortcutTimer);
    cell.click();
  }, 150);
}, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
